import { translate } from "../../util/translate"

export const movementHeaders = [
  {
    text: translate['movement.label.createdAt'],
    value: 'created_at',
    width: '150',
  },
  {
    text: translate['movement.label.description'],
    value: 'description',
  },
  {
    text: translate['movement.label.category'],
    value: 'category',
    width: '150',
  },
  {
    text: translate['movement.label.reason'],
    value: 'reason',
    width: '200',
  },
  {
    text: translate['movement.label.comment'],
    value: 'movement_comment',
    width: '260',
  },
  {
    text: translate['movement.label.total'],
    value: 'total',
    align: 'right',
    width: '150',
  },
]

export const adminMovementHeaders = [
  {
    text: translate['movement.label.customer'],
    value: 'real_estate',
    width: 300,
  },
  {
    text: translate['movement.label.createdAt'],
    value: 'created_at',
    width: 120,
  },
  {
    text: translate['movement.label.description'],
    value: 'description',
    width: '250',
  },
  {
    text: translate['movement.label.category'],
    value: 'category',
    width: 100,
  },
  {
    text: translate['movement.label.reason'],
    value: 'reason',
    width: 150,
  },
  {
    text: translate['movement.label.comment'],
    value: 'movement_comment',
    width: 260,
  },
  {
    text: translate['movement.label.total'],
    value: 'total',
    align: 'right',
    width: 150,
  },
]
